import { useState } from 'react';
import { alert, haptic } from '../../lib/telegram';
import { useT } from '../../lib/i18n';
import { api } from './api';

/**
 * «Язык сообщений»: the language of everything the bot sends this client
 * (server: PUT /api/coach/clients/:id/bot-language, sql/041). «По
 * умолчанию» keeps today's rules. The client's own app language is theirs
 * (their settings) and is not changed by this.
 */
export function BotLanguageCard({ clientId, value }: { clientId: string; value: 'ru' | 'en' | null }) {
  const t = useT();
  const [lang, setLang] = useState(value);
  const [busy, setBusy] = useState(false);
  async function pick(next: 'ru' | 'en' | null) {
    if (busy || next === lang) return;
    setBusy(true);
    try {
      await api(`/api/coach/clients/${clientId}/bot-language`, { method: 'PUT', body: JSON.stringify({ language: next }) });
      setLang(next);
      haptic.success();
    } catch (err: any) {
      haptic.error();
      await alert(t('co.cd.couldNot', { message: err.message }));
    } finally { setBusy(false); }
  }
  const choices: [('ru' | 'en' | null), 'co.cd.botLangDefault' | 'co.cd.botLangRu' | 'co.cd.botLangEn'][] =
    [[null, 'co.cd.botLangDefault'], ['ru', 'co.cd.botLangRu'], ['en', 'co.cd.botLangEn']];
  return (
    <>
      <div className="section-title">{t('co.cd.botLang')}</div>
      <div className="list">
        <div className="card">
          <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }} role="radiogroup" aria-label={t('co.cd.botLang')}>
            {choices.map(([v, key]) => (
              <button key={String(v)} type="button" className="chip" role="radio"
                aria-checked={lang === v} aria-pressed={lang === v} disabled={busy}
                onClick={() => { haptic.tap(); void pick(v); }}>{t(key)}</button>
            ))}
          </div>
          <div className="card__when" style={{ marginTop: 8 }}>{t('co.cd.botLangHint')}</div>
        </div>
      </div>
    </>
  );
}
